import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import { MessagesService } from 'src/app/services/messages.service';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { Uploads3Service } from 'src/app/services/uploads3.service';
import { SaberRolService } from 'src/app/services/saber-rol.service';
import { GetAniosService } from 'src/app/services/get-anios.service';
import { DeductivaService } from 'src/app/services/deductiva.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { PaginationService } from 'src/app/services/pagination.service';
import { FormatoNumberService } from 'src/app/services/formato-number.service';
import { FiltrarProyectosService } from 'src/app/services/filtrar-proyectos.service';

import { validacionRolService } from 'src/app/services/validacion-rol.service';

import { MESES } from 'src/app/constants/months.const';

@Component({
  selector: 'app-penalizacion-d',
  templateUrl: './penalizacion-d.component.html',
  styleUrls: ['./penalizacion-d.component.css']
})
export class PenalizacionDComponent {

  penalizacion = {
    FKId_Proyecto: 0,
    DedPen_NomProyecto: '',
    FKId_Direccion: 0,
    DedPen_Mes: '',
    DedPen_Año: '',
    DedPen_Ano: '',
    DedPen_Monto: 0,
    DepPen_VoBo: '',
    DepPen_Observaciones: ''
  }

  selectedFile: File | null = null;
  file: any = {
    file: File,
    url: '',
    type: '',
    name: ''

  };
  urlDocs: string[] = [];
  myDocs: any[] = [];
  nombrePDF: any;

  //Parametros componet viewpdf
  pdfUrl: string = '';
  modalVisible: boolean = false;
  namepdf: string = '';
  //*

  opE: any;
  control: any;
  proyectos: any[] = [];
  areas: any[] = [];
  token: any;
  anio: any;
  retrievedPenalizacion: any;
  rol: any;
  usuarioId: any;

  showErrorMessageProy: boolean = false;
  showErrorMessageFac: boolean = false;
  showErrorMessageMes: boolean = false;
  showErrorMessageAnio: boolean = false;
  showErrorMessageMonto: boolean = false;

  mensajeValidacionProy: string = '';
  mensajeValidacionFac: string = '';
  mensajeValidacionMes: string = '';
  mensajeValidacionAnio: string = '';
  mensajeValidacionMonto: string = '';

  mensaje = 'Campo requerido.';

  validacionRol: string = '';
  iconoMostrar: string = '';
  nameBoton: string = '';

  mostrarBtnPenalizacion: boolean = false;
  validacionCampos: boolean = true;

  mostrarBtnVoBo: boolean = false;
  anios: any;

  meses = MESES;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private pagination: PaginationService,
    private UploadService: Uploads3Service,
    private catalogService: CatalogsService,
    private getAniosService:GetAniosService,
    private messagesService: MessagesService,
    private saberRolService: SaberRolService,
    private requestsService: DeductivaService,
    private validacionBoton:validacionRolService,
    private navigationService: NavigationService,
    private formatoNumberService: FormatoNumberService,
    private filtrarProyectosService: FiltrarProyectosService
  ) { }

  ngOnInit() {
    this.verificacionUsuario();
    this.obtnerIcono();
  }

  obtnerIcono(){
    this.iconoMostrar = this.opE === '1' ? 'bi-arrow-left-circle' : 'bi-x-circle';
    this.nameBoton= this.opE === '1' ? 'Regresar' : 'Cancelar';
  }

  verificacionUsuario() {
    const { rol, usuarioId, token } = this.filtrarProyectosService.validacionUsuarios();
    this.token = token;
    this.usuarioId = usuarioId;
    this.rol = rol;

    this.navigationService.disableNavigation();
    this.opE = this.route.snapshot.paramMap.get('datos');

    if (this.opE === '1') {//obtendgo creditor para actualizar
      this.retrievedPenalizacion = this.sharedService.getDataArray();
      this.penalizacion.DedPen_Ano = this.retrievedPenalizacion.DedPen_Anio
      this.cargarpenalizacion(this.retrievedPenalizacion);
    }
    this.obtenerProyectos();
  }

  obtenerProyectos() {
    this.catalogService.getAllProjects(this.token).subscribe(
      (data: any) => {
        this.proyectos = Object.values(data);
        if (this.rol === 'Administrador') {
          this.proyectos = data;
        } else {
          const { proyectosFiltrados } = this.filtrarProyectosService.filtrarProyectos(data, this.usuarioId);
          this.proyectos = proyectosFiltrados;
        }
      }, (error) => {
        this.messagesService.showError('Se tiene problemas para todo el proyecto.');
      });
    this.obtenerAreas();
    this.getYears('');
  }


  getYears(seleccion:string){
    this.getAniosService.obtenerAnios().subscribe(
      (data: any) => {
        this.anios = data;
        console.log(data)
          // Verifica si el año seleccionado ya está en la lista
          if(seleccion!== ''){
            if (this.anios.includes(seleccion)) {
              // Si el año existe, mantenemos el valor
              this.penalizacion.DedPen_Ano = seleccion;
            } else {
                console.warn("El año seleccionado no está en la lista de años disponibles.");
            }
          }
      }, (err) => {
        this.messagesService.showError(err.message);
      });
  }


  obtenerAreas() {
    this.catalogService.getAllArea(this.token).subscribe(
      (data: any) => {
        this.areas = Object.values(data);
      });
  }

  esAdministrador(): boolean {
    if (this.rol === 'Administrador' && this.penalizacion.DepPen_VoBo === 'Aclaracion') {
      return true;
    } else {
      return false;
    }
  }

  async cargarpenalizacion(getpenalizacion: any) {
    this.penalizacion.DepPen_VoBo = getpenalizacion.DepPen_VoBo;
    this.penalizacion.DepPen_Observaciones = getpenalizacion.DepPen_Observaciones
    this.penalizacion.FKId_Proyecto = Number(getpenalizacion.FKId_Proyecto)
    this.penalizacion.DedPen_NomProyecto = getpenalizacion.DedPen_NomProyecto
    this.penalizacion.FKId_Direccion = Number(getpenalizacion.FKId_Direccion)
    this.penalizacion.DedPen_Mes = getpenalizacion.DedPen_Mes;
    this.penalizacion.DedPen_Monto = getpenalizacion.DedPen_Monto
    
    if(getpenalizacion.DedPen_Anio!==null){
      this.penalizacion.DedPen_Año = getpenalizacion.DedPen_Año.trim();
      this.penalizacion.DedPen_Ano = getpenalizacion.DedPen_Año.trim();
      this.getYears(getpenalizacion.DedPen_Año);
    }


    this.requestsService.getDocs(this.retrievedPenalizacion.Id_DedPen, this.token).subscribe(
      (data: any) => {
        this.myDocs = data
      }, (error) => {
        this.messagesService.showError('Se tiene problemas para todo el documento.');
      });

    this.cargarPDFs();
    this.facProImporteAsString();

        // Funcion que nos ayuda a validar los botones que se tienen quew mostrar
        this.mostrarBtnPenalizacion = this.validacionBoton.validacionBotonEditar(this.rol, this.penalizacion.DepPen_VoBo, this.opE,'Penalizacion');

        this.mostrarBtnVoBo = this.validacionBoton.validacionBotonVoBo(this.rol, this.penalizacion.DepPen_VoBo, this.opE,'Penalizacion');
    
        // Funcion que nos ayuda a poner disabled los input que se tienen que mostrar
        this.validacionCampos  = this.validacionBoton.validacionCampos(this.rol, this.penalizacion.DepPen_VoBo, this.opE,'Penalizacion');

    this.validacionRol = this.saberRolService.saberRol(getpenalizacion, this.usuarioId);
  }

  async validaFormulario(guardar: any, editar: any) {
    // this.penalizacion.DedPen_Año = this.anio;
    // const proyecto = this.proyectos.find(proyecto => proyecto.Id_Proyecto === String(this.penalizacion.FKId_Proyecto));
    // if (proyecto === undefined) {
    //   this.messagesService.showError('El campo proyecto no puede ser vacio');
    // } else {
    //   this.penalizacion.DedPen_NomProyecto = proyecto.Pry_Nombre
    // }
    // if (
    //   this.penalizacion.DedPen_NomProyecto === '' ||
    //   this.penalizacion.DedPen_Monto === 0 ||
    //   this.penalizacion.DedPen_Mes === '' ||
    //   this.penalizacion.DedPen_Año === ''
    // ) {
    //   this.messagesService.showError('Todos los campos son obligatorios');
    //   return;
    // }
    if (this.validarCamposVacios()) {
      return; // Si hay campos vacíos, termina la ejecución y no continúa con la edición
    }
    if (guardar === true) {
      this.guardar()
    }
    if (editar === true) {
      this.editar()
    }
  }

  guardarDatos(){
    this.regresarNumero();
    this.penalizacion.FKId_Direccion = Number(this.penalizacion.FKId_Direccion);
    this.penalizacion.DedPen_Monto = Number(this.penalizacion.DedPen_Monto);
    this.penalizacion.FKId_Proyecto = Number(this.penalizacion.FKId_Proyecto);
    this.penalizacion.DedPen_Ano = this.penalizacion.DedPen_Ano;

  }

  validarCamposVacios(): boolean {
    const campoNombres: { [key: string]: string } = {
      FKId_Proyecto: 'Proyecto',
      FKId_Direccion: 'Área que factura',
      DedPen_Mes: 'Mes de servicio',
      DedPen_Ano: 'Año de servicio',
      DedPen_Monto: 'Monto'
    };
  
    const camposInvalidos: string[] = [];
  
    // Verificación campo por campo
    if (!this.penalizacion.FKId_Proyecto || this.penalizacion.FKId_Proyecto === 0) {
      camposInvalidos.push(campoNombres['FKId_Proyecto']);
    }
  
    if (!this.penalizacion.FKId_Direccion || this.penalizacion.FKId_Direccion === 0) {
      camposInvalidos.push(campoNombres['FKId_Direccion']);
    }
  
    if (!this.penalizacion.DedPen_Mes || this.penalizacion.DedPen_Mes.trim() === '') {
      camposInvalidos.push(campoNombres['DedPen_Mes']);
    }
  
    if (!this.penalizacion.DedPen_Ano || this.penalizacion.DedPen_Ano.trim() === '') {
      camposInvalidos.push(campoNombres['DedPen_Ano']);
    }
  
    if (
      this.penalizacion.DedPen_Monto === null ||
      this.penalizacion.DedPen_Monto === undefined ||
      (String(this.penalizacion.DedPen_Monto).trim() === '' || String(this.penalizacion.DedPen_Monto).trim() === '0')
    ) {
      camposInvalidos.push(campoNombres['DedPen_Monto']);
    }
    
    
    
  
    // Mostrar mensaje si hay campos incompletos
    if (camposInvalidos.length > 0) {
      this.messagesService.showError(
        `Los siguientes campos están vacíos o incompletos: ${camposInvalidos.join(', ')}`
      );
      return true;
    }
  
    return false;
  }
  
  


  editar() {
    
    this.guardarDatos();

    if(this.rol === 'Administrador' && this.penalizacion.DepPen_VoBo === 'VoBo'){
      this.penalizacion.DepPen_VoBo = 'VoBo';
    }else if(this.rol === 'Administrador del proyecto' &&  this.penalizacion.DepPen_VoBo === 'Aclaracion') { 
      this.penalizacion.DepPen_VoBo = 'Pendiente';
    }

    this.requestsService.editpenalizacion(this.penalizacion, this.retrievedPenalizacion.Id_DedPen, this.token).subscribe(
      (res) => {
        this.aceptar(res.message);
      }, (err) => {
        this.messagesService.showError(err.error.error[0].message);
      }
    )
  }

  guardar() {
    this.guardarDatos();

    this.requestsService.createpenalizacion(this.penalizacion, this.token).subscribe(
      (res) => {
        this.aceptar(res.message);
        if (this.control === true) {
          this.retrievedPenalizacion = res.penalyzation
          this.saveDocument()
        }
      }, (err) => {
        this.messagesService.showError(err.error.error[0].message);
      }
    )
  }

  eliminar() {
    this.requestsService.deletepenalizacion(this.retrievedPenalizacion.Id_DedPen, this.token).subscribe(
      (res) => {
        this.aceptar(res.message);
      }, (err) => {
        this.messagesService.showError(err.error.error[0].message);
      }
    )
  }

  cancelar() {
    this.pagination.setLastAction('back');
    this.router.navigate(['/penalizacion']);
  }

  onFileSelected(event: any, folder: any) {
    const input = event.target as HTMLInputElement;
    if (input?.files && input.files.length > 0) {
      this.selectedFile = input.files[0] as File;
      this.saveFile(this.selectedFile, folder);
      this.selectedFile = null;
    } else {
      this.selectedFile = null;
    }
  }

  saveFile(file: any, folder: any) {
    this.UploadService.uploadToS3('penalizacion', file, folder).then((urlDoc: any) => {
      this.urlDocs.push(urlDoc);
      if (this.urlDocs.length > 0) {
        this.cargarPDFs();
        this.saveDocument();
      }
    }, (error) => {
      this.messagesService.showError(error);
    });
  }

  cargarPDFs() {
    this.myDocs = [];
    const urls: any[] = [];
    this.urlDocs.forEach((url: any) => {
      const urlObj = new URL(url);
      const pathParts = urlObj.pathname.split('/');
      const nombreArchivo = pathParts[pathParts.length - 1];
      this.nombrePDF = decodeURIComponent(nombreArchivo);
      this.file = {
        file: File,
        url: url,
        type: '',
        name: this.nombrePDF
      }
      this.myDocs.push(this.file)
      urls.push(url)
    });
    if (this.myDocs.length == 0) {
      this.urlDocs = [];
    }
    this.urlDocs = urls;
  }

  deleteFile(index: any, ficha: any, folder: any) {
    this.UploadService.deleteFileS3('penalizacion', folder, ficha.DedPenDoc_Nombre).then((res: any) => {
      this.urlDocs.splice(index, 1); // Elimina 1 elemento en la posición 'index'
      this.deleteDoc(ficha)
      this.cargarPDFs();
    }, (error) => {
      this.messagesService.showError(error);
      return;
    });
  }

  deleteDoc(ficha: any) {
    this.requestsService.deleteDoc(ficha.Id_DedPenDocumento, this.token).subscribe(
      (res) => {
        this.messagesService.showMessage(res.message)
        this.cargarpenalizacion(this.retrievedPenalizacion);
      }, (err) => {
        this.messagesService.showError(err.Message)
      }
    )
  }

  saveDocument() {
    if (!this.retrievedPenalizacion) {
      console.error('No se ha obtenido una penalización válida.');
      this.control = true
      this.validaFormulario(true, false)
      return;
    }

    const data = {
      FKId_DedPen: Number(this.retrievedPenalizacion.Id_DedPen),
      DedPenDoc_Nombre: this.nombrePDF,
      DedPenDoc_URL: this.urlDocs[0]
    };

    this.requestsService.SaveDocumentDP(data, this.token).subscribe(
      (res) => {
        this.messagesService.showMessage(res.message);
        this.urlDocs = [];
        if (this.opE === '1') {
          this.cargarpenalizacion(this.retrievedPenalizacion);
        }
        if (this.opE === '2') {
          // this.router.navigate(['/penalizacion']);
        }
      },
      (err) => {
        this.messagesService.showError(err.Message);
      }
    );
  }

  aceptar(message: string) {
    this.messagesService.showMessage(message);
    this.cancelar();
  }

  cambioEstatus() {
    const data = {
      DepPen_VoBo: "VoBo" //"Pendiente", "Aclaración", "VoBo"
    }
    this.requestsService.VoboP(data, this.retrievedPenalizacion.Id_DedPen, this.token).subscribe(
      (res) => {
        this.aceptar(res.message);
      }, (err) => {
        this.messagesService.showError('Error al cambiar el estatus.');
      }
    )
  }

  comentarios() {
    if (this.penalizacion.DepPen_Observaciones === '') {
      this.messagesService.showError('Es necesario colocar algún comentario.');
    } else {
      this.enviarComentario();
    }
  }

  enviarComentario() {
    const data = {
      DepPen_Observaciones: this.penalizacion.DepPen_Observaciones, //string
      DepPen_VoBo: "Aclaracion" //"Pendiente", "Aclaración", "VoBo"
    }
    this.requestsService.ComentariosP(data, this.retrievedPenalizacion.Id_DedPen, this.token).subscribe(
      (res) => {
        this.messagesService.showMessage(res.message);
        this.cancelar();
      }, (err) => {
        this.messagesService.showError('Error al enviar los comentarios.');
      }
    )
  }

  async openModal(document: any) {
    try {
      this.pdfUrl = await this.UploadService.getViewUrl('penalizacion', document.FKId_DedPen, document.DedPenDoc_Nombre);
      this.namepdf = document.DedPenDoc_Nombre;
      this.modalVisible = true;
    } catch (error: any) {
      this.messagesService.showError(error?.message || 'No se pudo abrir el documento.');
    }
  }

  async downloadDocument(document: any) {
    try {
      const url = await this.UploadService.getViewUrl('penalizacion', document.FKId_DedPen, document.DedPenDoc_Nombre);
      window.open(url, '_blank');
    } catch (error: any) {
      this.messagesService.showError(error?.message || 'No se pudo descargar el documento.');
    }
  }

  onModalClosed() {
    this.modalVisible = false;
  }

  // regresar a numero 
  regresarNumero() {
    let ingresado = this.penalizacion.DedPen_Monto;
    this.penalizacion.DedPen_Monto = this.formatoNumberService.regresarNumero(ingresado);
  }

  // funcion que nos permite poner las comas en los digitos
  facProImporteAsString(): any {
    let ingresado = this.penalizacion.DedPen_Monto;
    this.penalizacion.DedPen_Monto = this.formatoNumberService.facProImporteAsString(ingresado);
  }

  // Método para filtrar caracteres no numéricos y puntos
  filterInput(event: any): void {
    let inputValue = event.target.value;

    // Permitir solo números y un solo punto decimal
    let sanitizedValue = inputValue.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');

    // Verificar si el valor contiene un punto decimal
    if (sanitizedValue.indexOf('.') !== -1) {
      // Dividir el número en partes entera y decimal
      let partes = sanitizedValue.split('.');

      // Limitar la parte decimal a 2 dígitos
      let decimalPart = (partes[1] || '').substring(0, 2);

      // Formatear la parte entera con comas
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // Unir la parte entera con la parte decimal
      sanitizedValue = `${partes[0]}.${decimalPart}`;
    } else {
      // Si no hay punto decimal, solo agregar comas a la parte entera
      sanitizedValue = sanitizedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // Actualizar el valor del campo
    event.target.value = sanitizedValue;
    this.facProImporteAsString();
  }

  // mensajes de validación 
  mostrarMensaje(campo: any, tipo: string) {
    switch (tipo) {
      case 'proyecto':
        if ((campo.invalid && (campo.dirty || campo.touched)) || campo.value === '0' || campo.value === 0) {
          this.showErrorMessageProy = true;
          this.mensajeValidacionProy = this.mensaje;
        } else {
          this.showErrorMessageProy = false;
        }
        break;
      case 'factura':
        if ((campo.invalid && (campo.dirty || campo.touched)) || campo.value === '0' || campo.value === 0) {
          this.showErrorMessageFac = true;
          this.mensajeValidacionFac = this.mensaje;
        } else {
          this.showErrorMessageFac = false;
        }
        break;
      case 'mes':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageMes = true;
          this.mensajeValidacionMes = this.mensaje;
        } else {
          this.showErrorMessageMes = false;
        }
        break;
      case 'anio':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageAnio = true;
          this.mensajeValidacionAnio = this.mensaje;
        } else {
          this.showErrorMessageAnio = false;
        }
        break;
      case 'monto':
        if ((campo.invalid && (campo.dirty || campo.touched)) || this.penalizacion.DedPen_Monto === 0) {
          this.showErrorMessageMonto = true;
          this.mensajeValidacionMonto = this.mensaje;
        } else {
          this.showErrorMessageMonto = false;
        }
        break;
    }
  }
}
